(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AcrossTabs", [], factory);
	else if(typeof exports === 'object')
		exports["AcrossTabs"] = factory();
	else
		root["AcrossTabs"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition